import { TVehicle } from "types";
import { rollups, extent, min, max, sum, group } from "d3-array";

export const groupVehicles = (vehicles: TVehicle[]): any => {
  const preparedVehicles = vehicles.map((vehicle: TVehicle) => {
    return {
      ...vehicle,
      groupType: "modell",
      // groupType: vehicle.modell.modell_gruppe ? "gruppe" : "modell",
      groupId: vehicle.modell.id,
      group: "modell_" + vehicle.modell.id,
      // groupId: vehicle.modell.modell_gruppe
      //   ? vehicle.modell.modell_gruppe.id
      //   : vehicle.modell.id,
      // group: vehicle.modell.modell_gruppe
      //   ? "gruppe_" + vehicle.modell.modell_gruppe.id
      //   : "modell_" + vehicle.modell.id,
    };
  });

  const groupedVehicles = rollups(
    preparedVehicles,
    (v: any) => ({
      picture: () => {
        const match = v
          .sort((b: any, a: any) => (b.preis < a.preis ? -1 : 1))
          .find((e: any) => e.picturesCount > 1);
        if (match) return match.picturesPath + match.wgnr + "_1.jpg";
        return v[0].picturesPath + v[0].wgnr + "_1.jpg";
      },

      marke: v[0].modell.marke,
      modell: v[0].modell,
      id: v[0].wgnr,
      vorrat: sum(v, (d: any) => 1),
      rate: min(v, (d: any) => d.rate),
      preis: min(v, (d: any) => d.preis),
      km_min: min(v, (d: TVehicle) => d.km || undefined),
      km_max: max(v, (d: TVehicle) => d.km || undefined),
      erstzulassung_min: min(v, (d: TVehicle) => d.erstzulassung || undefined),
      erstzulassung_max: max(v, (d: TVehicle) => d.erstzulassung || undefined),
      groupType: v[0].groupType,
      groupId: v[0].groupId,
      group: v[0].group,
      fzarts: Array.from(group(v, ({ fzart }: any) => fzart.id)).map(
        ([id, elements]) => ({ id, count: elements.length }),
      ),
      aufbaubereiche: Array.from(
        group(v, ({ aufbau_bereich }: any) => aufbau_bereich.id),
      ).map(([id, elements]) => ({ id, count: elements.length })),

      wltp_co2klasse: extent(v, ({ wltp_co2klasse }: any) =>
        check(wltp_co2klasse),
      ),
      wltp_co2_emissionen: extent(v, ({ wltp_co2_emissionen }: any) =>
        check(wltp_co2_emissionen),
      ),
      wltp_kombiniert: extent(v, ({ wltp_kombiniert }: any) =>
        check(wltp_kombiniert),
      ),
      wltp_stromverbrauch_kombiniert: extent(
        v,
        ({ wltp_stromverbrauch_kombiniert }: any) =>
          check(wltp_stromverbrauch_kombiniert),
      ),
    }),
    (d: any) => d.group,
  );
  return groupedVehicles;
};

const check = (d: any) => (d || d === 0 ? d : null);
